import { sylvanus } from '~/services/serviceInstances';
import { Uuid } from '~/types/Uuid';

interface Request {
  modelId: Uuid;
  workflowId: Uuid;
}

type Response = void;

export const republishPromptModelWorkflowPrediction = async ({
  modelId,
  workflowId,
}: Request): Promise<Response> => {
  const response = await sylvanus.patch(
    `/model/${modelId}/predict/${workflowId}`,
  );

  return response;
};
